import { ActionsDropdown } from 'components/Buttons/ActionsDropdown'
import { ComposeMode } from './ComposePanel'
import {
  EmailDealActionCallbacks,
  buildActionContext,
  useEmailThreadActions,
} from './emailActions'

interface ThreadMessageMenuProps extends EmailDealActionCallbacks {
  onCompose?: (mode: ComposeMode) => void
  assignDealSubContent?: React.ReactNode
  isHidden?: boolean
}

/** Per-message 3-dot actions menu. */
export function ThreadMessageMenu({
  onCompose,
  assignDealSubContent,
  isHidden,
  ...dealCallbacks
}: ThreadMessageMenuProps) {
  const actions = useEmailThreadActions(
    buildActionContext(dealCallbacks, onCompose, assignDealSubContent, isHidden)
  )
  return <ActionsDropdown actions={actions} />
}
